export default class Timer {
  private timerStartedTimeStamp?: number;
  private timer: number | null = null;
  private internalDelay?: number;

  // eslint-disable-next-line no-useless-constructor
  constructor(private callback: () => void, private delay = 3000) {}

  start = () => {
    if (this.timer) throw Error('Timer is already started');

    this.timerStartedTimeStamp = Date.now();

    this.timer = window.setTimeout(this.callback, this.delay);
  };

  pause = () => {
    if (!this.timer) return;
    if (!this.timerStartedTimeStamp) throw Error('Start timer before pause');

    this.internalDelay = this.delay - (Date.now() - this.timerStartedTimeStamp);

    clearTimeout(this.timer);
  };

  stop = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timerStartedTimeStamp = undefined;
    }
  }

  resume = () => {
    if (!this.timer) return;

    this.timerStartedTimeStamp = Date.now();

    this.timer = window.setTimeout(this.callback, this.internalDelay);
  };
}
